import { render, staticRenderFns } from "./BowContentStickyMedia.vue?vue&type=template&id=0604f418&"
import script from "./BowContentStickyMedia.vue?vue&type=script&lang=js&"
export * from "./BowContentStickyMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BowHeading: require('/workspace/components/atoms/BowHeading/BowHeading.vue').default,BowAnimation: require('/workspace/components/base/BowAnimation/BowAnimation.vue').default,BowText: require('/workspace/components/atoms/BowText/BowText.vue').default,BowMedia: require('/workspace/components/molecules/BowMedia/BowMedia.vue').default,BowSticky: require('/workspace/components/base/BowSticky/BowSticky.vue').default,BowCallToAction: require('/workspace/components/molecules/BowCallToAction/BowCallToAction.vue').default})
